/* eslint-disable no-unused-vars */
import React from 'react';
import "./AboutPage.css";
import images from '../../Asset/Img/img';
import video from "../../Asset/Video/video"

function AboutPage() {

  
  return (
    <div className='about-container'>

      <div className='about-content'>
        {/* header section start */}
        <div className='about-header'>

          <div className='about-header-text'>
            <h4>HAKKIMIZDA</h4>
          </div>

        </div>
        {/* header section end */}

        {/* Promotion section start */}

        <div className='promotion-container'>
          <div className='promotion-header'>
            <h3>High Performance Compounds Kauçuk A.Ş.</h3>
            <button>Tanıtım Videosu <img src={images.detailBtnIcon} alt="detail-icon" /></button>
          </div>

          <p>High Performance Compounds Kauçuk A.Ş. Bursa Hasanağa Sanayi Bölgesi’nde 2016 yılında kurulmuştur. High PCK, Ligom S.p.A. şirketinin dahil olduğu TSF S.p.A grubunun (İtalya) parçasıdır.
          </p>

          <p>1984 yılında kurulan TSF S.p.A., yıllar içerisinde özel kauçuk karışımlarının -Floroelastomerler (FKM) ve Perfluoroelastmers (FFKM), Silikonlar ( VMQ-2002’den beri resmi Wacker İtalya distribütörü), Florosilikonlar (FVMQ)- araştırılması, geliştirilmesi ve pazarlanması konularında az sayıda İtalyan referans şirketlerinden biri haline gelmiştir. </p>

          <p>Üretim alanımız, maksimum esneklik, hızlı cevap verme ve çapraz kontaminasyonların ortadan kaldırılması için fiziksel olarak ayrılmış hatlardan oluşmaktadır. Pazar yaklaşımımız, sadece otomotiv endüstrisinden değil, beklentinin yüksek olduğu diğer sektörlerde de en zorlu ve güncel şartnameleri karşılamak için geliştirilmiş yüksek teknoloji hamurları sağlamaya dayanmaktadır. </p>

          <p>
            Tüm reçetelerimiz sadece belirtilen şartname ve standartları yerine getirmekle kalmayıp, aynı zamanda müşterilerimizin kalite & üretilebilirlik optimizasyonu ihtiyacına cevap verecek şekilde tasarlanmıştır. High PCK, Türkiye’ de kendi tesisinden ve İtalya’daki TSF tesislerinden çok çeşitli ve yüksek kalitede performans hamurları için teklif verebilir. </p>

          <p>Son ve en önemli olarak, kimyager ve mühendislerimiz bitmiş ürüne uygun hamur seçimi veya geliştirilmesi konusunda müşteri ile çalışır ve en iyi teknik ve ticari hizmeti sağlamak için vulkanizasyon ve kalıplama için önerilerde bulunabilir.</p>

        </div>

        {/* Promotion section end */}

        {/* history section start */}

        <div className='history-container'>

          <div className='schema-content'>
            <img src={images.historyImg} alt="schema-img" />
          </div>

          <div className='schema-content-media'>
            <img src={images.historyMobile} alt="schema-img-mobile" />
          </div>
        </div>

        {/* history section end */}

        {/* vision-and-mission section start*/}

        <div className='vision-and-mission-container'>

          <div className='vision'>
            <h2>Vizyon</h2>
            <p>1984 yılında kurulan TSF S.p.A., yıllar içerisinde özel kauçuk karışımlarının -Floroelastomerler (FKM) ve Perfluoroelastmers (FFKM), Silikonlar ( VMQ-2002’den beri resmi Wacker İtalya distribütörü), Florosilikonlar (FVMQ)- araştırılması, geliştirilmesi ve pazarlanması konularında az sayıda İtalyan referans şirketlerinden biri haline gelmiştir. </p>
            <p>
              Üretim alanımız, maksimum esneklik, hızlı cevap verme ve çapraz kontaminasyonların ortadan kaldırılması için fiziksel olarak ayrılmış hatlardan oluşmaktadır. Pazar yaklaşımımız, sadece otomotiv endüstrisinden değil, beklentinin yüksek olduğu diğer sektörlerde de en zorlu ve güncel şartnameleri karşılamak için geliştirilmiş yüksek teknoloji hamurları sağlamaya dayanmaktadır. </p>
          </div>

          <div className='mission'>
            <h2>Misyon</h2>
            <p>High Performance Compounds Kauçuk A.Ş. Bursa Hasanağa Sanayi Bölgesi’nde 2016 yılında kurulmuştur. High PCK, Ligom S.p.A. şirketinin dahil olduğu TSF S.p.A grubunun (İtalya) parçasıdır. </p>
            <p>1984 yılında kurulan TSF S.p.A., yıllar içerisinde özel kauçuk karışımlarının -Floroelastomerler (FKM) ve Perfluoroelastmers (FFKM), Silikonlar ( VMQ-2002’den beri resmi Wacker İtalya distribütörü), Florosilikonlar (FVMQ)- araştırılması, geliştirilmesi ve pazarlanması konularında az sayıda İtalyan referans şirketlerinden biri haline gelmiştir. </p>
            <p>Üretim alanımız, maksimum esneklik, hızlı cevap verme ve çapraz kontaminasyonların ortadan kaldırılması için fiziksel olarak ayrılmış hatlardan oluşmaktadır. Pazar yaklaşımımız, sadece otomotiv endüstrisinden değil, beklentinin yüksek olduğu diğer sektörlerde de en zorlu ve güncel şartnameleri karşılamak için geliştirilmiş yüksek teknoloji hamurları sağlamaya dayanmaktadır. </p>
          </div>
        </div>
        {/* vision-and-mission section end*/}
        {/* Gallery section start */}
        <div className='gallery-container'>

          <div className='gallery-header'>
            <h3>GALERİ</h3>
          </div>

          <div className='gallery-content'>

            <div className='gallery-video-container'>
              <video src={video.highVideo} autoPlay loop muted></video>
            </div>

            <div className='gallery-img-container'>
              <div> <img src={images.gallery1} alt="gallery-img" /> </div>
              <div> <img src={images.gallery2} alt="gallery-img" /> </div>
              <div> <img src={images.gallery3} alt="gallery-img" /> </div>
              <div> <img src={images.gallery4} alt="gallery-img" /> </div>
            </div>
          </div>
        </div>
        {/* Gallery section end */}
      </div>
    </div>
  )
}

export default AboutPage